export const ROWS_PER_PAGE = 2;
export const TOURNAMENT_TILE_MAX_WIDTH = 282;
export const TOURNAMENT_TILE_MIN_HEIGHT_IN_SPACING = 33;
export const FULL_HEIGHT_TOURNAMENT_ROWS_PER_PAGE = 4;
